
export function getLegalRepresentative(legalRepresentativeRepository) {
  return legalRepresentativeRepository.get();
}
